import React from 'react';
import HomeMain from './HomeMain';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const HomeOnePage = () => {
  return (
    <>
      <Header isOnePage />

      <HomeMain />

      <Footer />
    </>
  );
};

export default HomeOnePage;
